import React from "react";

import type { MonitorCheckStatusConfiguredSilencingRule } from "../../../../../../common/openapi";

import { AppliesTo } from "./common/applies-to";
import { InternalPastRuleTiming } from "./common/internal-past-rule-timing";
import { PastRuleAlert } from "./common/past-rule-alert";
import { SilencingNote } from "./common/silencing-note";

export function InternalPastWithoutSelector({ rule }: { rule: MonitorCheckStatusConfiguredSilencingRule }) {
	return (
		<div className="drawer-body flex flex-col gap-6">
			<PastRuleAlert />
			<InternalPastRuleTiming rule={rule} />
			<SilencingNote note={rule.note} />
			<AppliesTo />
		</div>
	);
}
